import { useQueryClient } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';

import { createRoutesConfig } from 'routes/NewRoutes';

import { RETURN_URL_EXCEPTION } from 'static/Constants';

const createAppRouter = ({ messages, returnUrl, queryClient, ability }) => {
  return createBrowserRouter([
    {
      path: '/',
      element: <App messages={messages} />,
      children: createRoutesConfig({
        returnUrl,
        queryClient,
        ability,
      }),
    },
  ]);
};

const RootRouter = ({ messages, ability }) => {
  const pathName = window.location.pathname;
  const queryString = window.location.search;

  const queryClient = useQueryClient();

  const returnUrl = RETURN_URL_EXCEPTION.includes(pathName)
    ? '/'
    : pathName + queryString;

  const router = createAppRouter({ messages, returnUrl, queryClient, ability });

  return <RouterProvider router={router} />;
};

export default RootRouter;
